import { useEffect, useState } from "react";
import { api } from "@/api";
import { LayoutAutenticado } from "@/componentes/LayoutAutenticado";
import { Users, Trophy, Wallet, Target, Flame, Calendar } from "lucide-react";

export default function DashboardAdmin() {
  const [d, setD] = useState({});

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/dashboard/admin");
      setD(data || {});
    })();
  }, []);

  return (
    <LayoutAutenticado>
      <div data-testid="dashboard-admin">
        <div className="mb-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Painel Administrativo</div>
          <h1 className="font-heading text-4xl font-bold uppercase mt-1">Visão Geral</h1>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-10">
          <Card titulo="Apostadores" valor={d.totalApostadores ?? 0} icone={Users} />
          <Card titulo="Pagos" valor={d.apostadoresPagos ?? 0} icone={Wallet} cor="verde" />
          <Card titulo="Pendentes" valor={d.apostadoresPendentes ?? 0} icone={Wallet} cor="amarelo" />
          <Card titulo="Jogos" valor={d.totalJogos ?? 0} icone={Calendar} />
          <Card titulo="Encerrados" valor={d.jogosEncerrados ?? 0} icone={Flame} cor="verde" />
          <Card titulo="Palpites" valor={d.totalPalpites ?? 0} icone={Target} />
        </div>

        <div className="surface-card rounded-2xl p-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Financeiro</div>
          <h2 className="font-heading text-2xl font-bold uppercase mt-1">Total Arrecadado</h2>
          <div className="font-heading font-black text-6xl text-verdebrasil tabular-nums mt-4" data-testid="total-arrecadado">
            R$ {Number(d.totalArrecadado || 0).toFixed(2)}
          </div>
          <p className="text-sm text-white/60 mt-2">Soma dos pagamentos com status PAGO.</p>
        </div>
      </div>
    </LayoutAutenticado>
  );
}

function Card({ titulo, valor, icone: Icone, cor = "branco" }) {
  const cores = {
    verde: "text-verdebrasil",
    amarelo: "text-amarelobrasil",
    branco: "text-white",
  };
  return (
    <div className="surface-card rounded-2xl p-4" data-testid={`card-${titulo.toLowerCase()}`}>
      <Icone className={`w-4 h-4 ${cores[cor]} mb-2`} />
      <div className="font-heading font-black text-3xl tabular-nums">{valor}</div>
      <div className="text-[10px] uppercase tracking-widest text-white/40 mt-1">{titulo}</div>
    </div>
  );
}
